import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circle-p',
  templateUrl: './circle-p.component.html',
  styleUrls: ['./circle-p.component.scss']
})
export class CirclePComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {


  }

}
